// Constants and regex used for parsing mentions and URLs

export const MENTION_REGEX = /@([\w.]+)/g;

export const URL_REGEX =
  /(?:https?:\/\/(?:www\.)?|www\.)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?/g;
